
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#2C7FE1","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.382.238C5.555.238 0 5.793 0 12.62 0 19.446 5.555 25 12.382 25c6.826 0 12.381-5.555 12.381-12.381 0-6.827-5.555-12.382-12.381-12.382zm0 23.81C6.08 24.048.954 18.92.954 12.62c0-6.302 5.126-11.428 11.428-11.428 6.3 0 11.428 5.126 11.428 11.428 0 6.3-5.127 11.428-11.428 11.428z"}}),_c('path',{attrs:{"d":"M18.334 12.143h-5.476V6.904a.478.478 0 00-.953 0v5.239H6.429a.477.477 0 000 .953h5.476v5.713a.477.477 0 00.953 0v-5.713h5.476a.478.478 0 000-.953z"}})])])
          )
        }
      }
    